export default {
    congratulation: 'Congratulation',
    message: 'Save success',
    close: 'Close'
}
